import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

/**
 * ErrorMessage — soft Radix-style banner for wizard validation errors.
 */
const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div
      role="alert"
      className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-xl px-3 py-2 mb-4"
    >
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        className="text-red-500 mt-0.5 shrink-0"
      />
      <span className="text-sm text-red-700">{message}</span>
    </div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
